import React, { useEffect } from "react";
import { Form, Input, Button, Row, Col, message, Modal } from "antd";
import { updateDiscountCode } from "../../../api/discount.service";

const EditDiscountCodeModal = ({ vehicleData, fetchVehicles, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                ...vehicleData,
            });
        }
    }, [vehicleData, form]);

    const onFinish = async (values) => {

        try {
            await updateDiscountCode(vehicleData.id, values);
            message.success("Discount Code updated successfully!");
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            message.error(error);
            console.error("Error:", error);
        }
    };

    return (
        <Modal className="vt-modal" footer={null} destroyOnClose title={`${isViewOnly ? 'View' : 'Edit'} Discount Code`} open={isModalOpen} onOk={handleOk} onClose={handleCancel} onCancel={handleCancel}>
            <Form disabled={isViewOnly} layout="vertical" form={form} onFinish={onFinish}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Discount Code" name="discountCode" rules={[{ required: true, message: "Please enter discount code" }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Discount Percent" name="discountPercent" rules={[{ required: true, message: "Please enter discount percent" }]}>
                            <Input type="number" min={0} max={100} />
                        </Form.Item>
                    </Col>
                </Row>

                {!isViewOnly && <Form.Item>
                    <Button type="primary" htmlType="submit">Update</Button>
                    <Button style={{ marginLeft: 8 }} onClick={() => {
                        setIsModalOpen(false);
                    }}>Cancel</Button>
                </Form.Item>}
            </Form>
        </Modal>
    );
};

export default EditDiscountCodeModal;
